/**
 * Feedback aptico (Taptic Engine) per l'app nativa: breve, coerente, complementare al feedback visivo
 * (HIG → Playing haptics). No-op su web e quando l'utente li disattiva (`localStorage.ml_haptics = "0"`).
 * iOS rispetta comunque l'impostazione di sistema «Feedback del sistema».
 */
import { Capacitor } from "@capacitor/core";
import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";

function enabled(): boolean {
  try {
    return Capacitor.isNativePlatform() && localStorage.getItem("ml_haptics") !== "0";
  } catch {
    return Capacitor.isNativePlatform();
  }
}

const swallow = () => undefined;

export const haptic = {
  /** tocco leggero: soglia raggiunta, apertura, conferma di un gesto */
  light() {
    if (enabled()) void Haptics.impact({ style: ImpactStyle.Light }).catch(swallow);
  },
  /** azione con più peso: rilascio di un elemento, conferma importante */
  medium() {
    if (enabled()) void Haptics.impact({ style: ImpactStyle.Medium }).catch(swallow);
  },
  /** cambio di selezione (interruttori, segmenti, schede) */
  selection() {
    if (!enabled()) return;
    void Haptics.selectionStart()
      .then(() => Haptics.selectionChanged())
      .then(() => Haptics.selectionEnd())
      .catch(swallow);
  },
  success() {
    if (enabled()) void Haptics.notification({ type: NotificationType.Success }).catch(swallow);
  },
  warning() {
    if (enabled()) void Haptics.notification({ type: NotificationType.Warning }).catch(swallow);
  },
  error() {
    if (enabled()) void Haptics.notification({ type: NotificationType.Error }).catch(swallow);
  },
};
